import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { t } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { lang } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [step, setStep] = useState("creds");
  const [ticket, setTicket] = useState("");
  const [code, setCode] = useState("");

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      if (r.data.requires_2fa) {
        setTicket(r.data.ticket);
        setStep("totp");
      } else {
        toast.success("OK");
        nav("/admin");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  async function verify(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login/verify", { ticket, code });
      toast.success("OK");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid code");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main data-testid="admin-login-page" className="max-w-md mx-auto px-6 py-20">
      <h1 className="font-serif-display text-5xl font-bold tracking-tighter text-gray-900">
        {t("admin_login_title", lang)}
      </h1>
      <form onSubmit={step === "creds" ? submit : verify} className="mt-10 space-y-5 bg-white border border-gray-200 rounded-2xl p-8">
        {step === "creds" ? (
          <>
            <div>
              <Label className="text-[11px] tracking-eyebrow text-gray-500">
                {t("email", lang)}
              </Label>
              <Input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 py-6 bg-white border-gray-200 focus-visible:ring-[#E85D04]" />
            </div>
            <div>
              <Label className="text-[11px] tracking-eyebrow text-gray-500">
                {t("password", lang)}
              </Label>
              <Input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 py-6 bg-white border-gray-200 focus-visible:ring-[#E85D04]" />
            </div>
          </>
        ) : (
          <div>
            <Label className="text-[11px] tracking-eyebrow text-gray-500">2FA code (6 digits)</Label>
            <Input data-testid="admin-totp" inputMode="numeric" maxLength={6} required value={code} onChange={(e) => setCode(e.target.value)} className="mt-2 py-6 text-center font-mono-code text-2xl tracking-widest bg-white border-gray-200 focus-visible:ring-[#E85D04]" />
          </div>
        )}
        <Button type="submit" data-testid="admin-login-btn" disabled={loading} className="w-full rounded-full bg-[#E85D04] hover:bg-[#DC2F02] text-white py-6">
          {loading ? t("loading", lang) : step === "creds" ? t("login", lang) : "Verify"}
        </Button>
      </form>
    </main>
  );
}
